import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../App.css";
import { useState, useRef, useEffect, useMemo, useCallback, memo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-material.css";
import Footer from "../Footer/Footer";
import GLOBALS from "../../utils/Globals";
import URLRenderer from "../AgGrid/URLRenderer";
import FileTypeIconRenderer from "../AgGrid/FileTypeIconRenderer";
import ViewActionRenderer from '../AgGrid/ViewActionRenderer';
import ViewFileModal from '../Modal/ViewFileModal';
import ExportedFileActionRenderer from '../AgGrid/ExportedFileActionRenderer';
import { Alert, Spinner, Button, Modal } from "react-bootstrap";
import { FaTriangleExclamation, FaWifi, FaTrash } from "react-icons/fa6";
import { MdRefresh } from "react-icons/md";
import { toast } from 'react-toastify';
import axios from 'axios';
import {
  CellStyleModule,
  ClientSideRowModelModule,
  ModuleRegistry,
  ValidationModule,
  createGrid,
} from "ag-grid-community";


LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-067893}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{nutrad}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{nutrad_portal}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{nutrad_portal}_need_to_be_licensed___{nutrad_portal}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{29_October_2025}____[v3]_[01]_MTc2MTY5NjAwMDAwMA==71e88be6064d0b1886823ed0ecdbe20c"
);

function ViewExportedFiles() {
  const [rowData, setRowData] = useState();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [renameLoading, setRenameLoading] = useState(false);

  const fetchExportedFiles = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const baseURLGetS3 =
        process.env.REACT_APP_ENV === "PROD"
          ? GLOBALS.PROD.baseURLGetS3
          : GLOBALS.DEV.baseURLGetS3;

      const response = await fetch(baseURLGetS3);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const rowData = await response.json();

      console.log('=== S3 DATA DEBUG ===');
      console.log('Full rowData:', rowData);
      if (rowData && rowData.length > 0) {
        console.log('First item keys:', Object.keys(rowData[0]));
        console.log('First item:', rowData[0]);

        // Check for various possible date field names
        const possibleDateFields = ['last_modified', 'lastModified', 'date_modified', 'modified', 'timestamp', 'created_at', 'updated_at'];
        possibleDateFields.forEach(fieldName => {
          if (rowData[0][fieldName] !== undefined) {
            console.log(`Found date field '${fieldName}':`, rowData[0][fieldName]);
            console.log(`Type:`, typeof rowData[0][fieldName]);
          }
        });

        // Check a few more items
        rowData.slice(0, 2).forEach((item, index) => {
          console.log(`Item ${index}:`, item);
        });
      }
      console.log('==================');
      setRowData(rowData);
    } catch (err) {
      console.error("Error fetching exported files:", err);

      // Handle different types of errors
      let errorMessage = 'Failed to load exported files. Please try again.';
      let errorType = 'general';

      if (err.name === 'TypeError' && err.message.includes('Failed to fetch')) {
        errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
        errorType = 'connection';
      } else if (err.message.includes('ERR_CONNECTION_REFUSED') || err.message.includes('ECONNREFUSED')) {
        errorMessage = 'The file service is currently unavailable. Please try again in a few moments.';
        errorType = 'connection';
      } else if (err.message.includes('status: 404')) {
        errorMessage = 'Exported files service not found. Please contact support.';
        errorType = 'notfound';
      } else if (err.message.includes('status: 5')) {
        errorMessage = 'Server error occurred while loading files. Please try again later.';
        errorType = 'server';
      } else if (err.message.includes('status: 401') || err.message.includes('status: 403')) {
        errorMessage = 'Access denied. Please check your permissions or log in again.';
        errorType = 'auth';
      }

      setError({ message: errorMessage, type: errorType, originalError: err });
      setRowData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchExportedFiles();
  }, [fetchExportedFiles]);

  console.log(rowData);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      editable: true,
      //filter: true
    };
  });

  const handleViewFile = (fileData) => {
    setSelectedFile({
      url: fileData.link,
      name: fileData.file_name
    });
    setShowModal(true);
  };

  const handleSelectionChanged = (event) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data);
    setSelectedRows(selectedData);
  };

  const handleBulkDelete = () => {
    if (selectedRows.length === 0) {
      toast.warning('Please select files to delete', {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }
    setShowBulkDeleteModal(true);
  };

  const confirmBulkDelete = async () => {
    setBulkDeleteLoading(true);
    try {
      const baseURLDeleteS3FilesBulk =
        process.env.REACT_APP_ENV === "PROD"
          ? GLOBALS.PROD.baseURLDeleteS3FilesBulk
          : GLOBALS.DEV.baseURLDeleteS3FilesBulk;

      const fileNames = selectedRows.map(row => row.file_name);

      const response = await axios.delete(baseURLDeleteS3FilesBulk, {
        data: { file_names: fileNames }
      });

      setShowBulkDeleteModal(false);

      // Remove successfully deleted files from the grid
      if (response.data.successful_deletes && response.data.successful_deletes.length > 0) {
        const filesToRemove = rowData.filter(row =>
          response.data.successful_deletes.includes(row.file_name)
        );

        // Update the row data by removing deleted files
        const updatedRowData = rowData.filter(row =>
          !response.data.successful_deletes.includes(row.file_name)
        );
        setRowData(updatedRowData);
        setSelectedRows([]);
      }

      // Show success/partial success message
      if (response.data.status === 'success') {
        toast.success(`Successfully deleted ${response.data.total_successful} files`, {
          position: "bottom-right",
          autoClose: 3000,
        });
      } else if (response.data.status === 'partial_success') {
        toast.warning(`Deleted ${response.data.total_successful} files. ${response.data.total_failed} files failed to delete.`, {
          position: "bottom-right",
          autoClose: 5000,
        });
      }

      // Show details of failed deletions if any
      if (response.data.failed_deletes && response.data.failed_deletes.length > 0) {
        console.error('Failed deletions:', response.data.failed_deletes);
      }

    } catch (error) {
      console.error('Error during bulk delete:', error);
      toast.error('Failed to delete files', {
        position: "bottom-right",
        autoClose: 3000,
      });
    } finally {
      setBulkDeleteLoading(false);
    }
  };

  const cancelBulkDelete = () => {
    setShowBulkDeleteModal(false);
  };

  const handleRenameLegacyFiles = async () => {
    setRenameLoading(true);
    try {
      const url =
        process.env.REACT_APP_ENV === "PROD"
          ? GLOBALS.PROD.baseURLRenamePublishedOutputs
          : GLOBALS.DEV.baseURLRenamePublishedOutputs;

      const response = await axios.post(url);
      const { renamed_count, skipped_count, errors } = response.data;

      if (errors && errors.length > 0) {
        toast.warning(
          `Renamed ${renamed_count} file(s), skipped ${skipped_count}. ${errors.length} error(s). Check console for details.`,
          { position: "bottom-right", autoClose: 6000 }
        );
        console.warn('Rename errors:', errors);
      } else if (renamed_count > 0) {
        toast.success(
          `Renamed ${renamed_count} file(s) to descriptive names. Skipped ${skipped_count} already-named file(s).`,
          { position: "bottom-right", autoClose: 4000 }
        );
      } else {
        toast.info(
          `No files needed renaming. ${skipped_count} file(s) already have descriptive names.`,
          { position: "bottom-right", autoClose: 3000 }
        );
      }

      // Refresh the file list to show updated names
      fetchExportedFiles();
    } catch (err) {
      console.error('Error renaming files:', err);
      toast.error('Failed to rename legacy files.', { position: "bottom-right", autoClose: 3000 });
    } finally {
      setRenameLoading(false);
    }
  };

  const [colDefs, setColDefs] = useState([
    {
      headerName: "File Name",
      field: "file_name",
      filter: "agTextColumnFilter",
      cellRenderer: FileTypeIconRenderer,
      flex: 2, // Give more space to filename column
    },
    {
      headerName: "Size",
      field: "size",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "URL",
      field: "link",
      cellRenderer: URLRenderer,
      width: 150,  // Set a fixed width for the URL column
      flex: 0,     // Disable flex to maintain fixed width
      sortable: false,  // Disable sorting for this column
      filter: false,    // Disable filtering for this column
    },
    {
      headerName: "Last Modified",
      field: "last_modified",
      filter: "agDateColumnFilter",
      valueFormatter: (params) => {
        if (!params.value) {
          return "";
        }

        try {
          let date;

          // Handle MongoDB date format: {$date: '2025-05-01T16:46:02Z'}
          if (typeof params.value === 'object' && params.value.$date) {
            console.log('Parsing MongoDB date format:', params.value);
            date = new Date(params.value.$date);
          }
          // Try different parsing methods based on the value type and format
          else if (typeof params.value === 'number') {
            // Unix timestamp (seconds or milliseconds)
            if (params.value < 10000000000) {
              // Likely seconds, convert to milliseconds
              date = new Date(params.value * 1000);
            } else {
              // Likely milliseconds
              date = new Date(params.value);
            }
          } else if (typeof params.value === 'string') {
            // String date - try direct parsing
            date = new Date(params.value);

            // If that fails, try parsing as Unix timestamp
            if (isNaN(date.getTime())) {
              const numValue = parseFloat(params.value);
              if (!isNaN(numValue)) {
                if (numValue < 10000000000) {
                  date = new Date(numValue * 1000);
                } else {
                  date = new Date(numValue);
                }
              }
            }
          } else {
            // Try direct conversion
            date = new Date(params.value);
          }

          // Check if the date is valid
          if (isNaN(date.getTime())) {
            console.warn('Could not parse date:', params.value, typeof params.value);
            return "Invalid Date";
          }

          // Format to local time
          return date.toLocaleString(navigator.language || 'en-US', {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
          });

        } catch (error) {
          console.error('Error formatting date:', error, 'Value:', params.value);
          return "Invalid Date";
        }
      },
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          try {
            let cellDate;

            // Handle MongoDB date format: {$date: '2025-05-01T16:46:02Z'}
            if (typeof cellValue === 'object' && cellValue.$date) {
              cellDate = new Date(cellValue.$date);
            } else {
              cellDate = new Date(cellValue);
            }

            // Check if the date is valid
            if (isNaN(cellDate.getTime())) {
              console.warn('Invalid date in filter comparator:', cellValue);
              return 0; // Treat invalid dates as equal
            }

            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
            return 0;
          } catch (error) {
            console.error('Error in date filter comparator:', error, 'Value:', cellValue);
            return 0; // Treat error cases as equal
          }
        },
      },
      sortable: true,
      sort: "desc",
    },
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: ExportedFileActionRenderer,
      width: 100, // Reduced width since we only have icons now
      sortable: false,
      filter: false,
    }
  ]);

  const rowSelection = useMemo(() => {
    return {
      mode: "multiRow",
      checkboxes: true,
    };
  }, []);

  // Error state
  if (error) {
    return (
      <>
        <br></br>
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-xl font-semibold text-gray-900">View Exported Files</h1>
              <br></br>
            </div>
          </div>

          <Alert variant="danger" className="d-flex align-items-center">
            <FaTriangleExclamation className="me-3" size={24} />
            <div className="flex-grow-1">
              <h5 className="alert-heading mb-2">Loading Error</h5>
              <p className="mb-2">{error.message}</p>
              {error.type === 'connection' && (
                <div className="small text-muted mb-3">
                  <FaWifi className="me-1" />
                  This usually indicates a network connectivity issue or the file service is temporarily unavailable.
                </div>
              )}
              <Button
                variant="outline-danger"
                size="sm"
                onClick={fetchExportedFiles}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Retrying...
                  </>
                ) : (
                  <>
                    <MdRefresh className="me-1" />
                    Try Again
                  </>
                )}
              </Button>
            </div>
          </Alert>
        </div>
        <Footer />
      </>
    );
  }

  // Loading state
  if (loading) {
    return (
      <>
        <br></br>
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-xl font-semibold text-gray-900">View Exported Files</h1>
              <br></br>
            </div>
          </div>

          <div className="text-center py-12">
            <Spinner animation="border" role="status" className="mb-3" size="lg">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="text-gray-600">Loading exported files...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  // Success state
  return (
    <>
      <br></br>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold text-gray-900">
              View Exported Files
              <span className="text-base font-normal text-gray-600 ml-3">
                ({rowData?.length || 0} {(rowData?.length || 0) === 1 ? 'file' : 'files'})
              </span>
            </h1>
          </div>
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none d-flex gap-2">
            <Button
              variant="outline-secondary"
              onClick={handleRenameLegacyFiles}
              disabled={renameLoading}
              className="d-flex align-items-center"
            >
              {renameLoading ? (
                <><Spinner animation="border" size="sm" className="me-2" />Renaming...</>
              ) : (
                'Rename Legacy Files'
              )}
            </Button>
            <Button
              variant="outline-danger"
              onClick={handleBulkDelete}
              disabled={selectedRows.length === 0}
              className="d-flex align-items-center"
            >
              <FaTrash className="me-2" />
              Delete Selected ({selectedRows.length})
            </Button>
          </div>
        </div>
        <br></br>

        {!rowData || rowData.length === 0 ? (
          <Alert variant="info" className="text-center">
            <h5>No Exported Files Available</h5>
            <p className="mb-0">There are currently no exported files to display. Files will appear here once documents are exported.</p>
          </Alert>
        ) : (
          <div
            className="ag-theme-material" // applying the Data Grid theme
            style={{ height: 800 }}
          >
            <AgGridReact
              rowData={rowData}
              animateRows={true}
              columnDefs={colDefs}
              rowSelection={rowSelection}
              onSelectionChanged={handleSelectionChanged}
              //rowClassRules={rowClassRules}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={[10, 20]}
              defaultColDef={defaultColDef}
              context={{
                onViewFile: handleViewFile,
                onFileDeleted: (deletedFileName) => {
                  // Update the row data by removing the deleted file
                  const updatedRowData = rowData.filter(row => row.file_name !== deletedFileName);
                  setRowData(updatedRowData);
                  // Also update selected rows if the deleted file was selected
                  setSelectedRows(prev => prev.filter(row => row.file_name !== deletedFileName));
                }
              }}
            />
          </div>
        )}
      </div>
      <ViewFileModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        fileUrl={selectedFile?.url}
        fileName={selectedFile?.name}
      />

      {/* Bulk Delete Confirmation Modal */}
      <Modal
        show={showBulkDeleteModal}
        onHide={cancelBulkDelete}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Bulk Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center">
            <div className="text-danger me-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
              </svg>
            </div>
            <div>
              <h5 className="mb-2">Delete {selectedRows.length} Files</h5>
              <p className="mb-2">Are you sure you want to delete the following files? This action cannot be undone.</p>
              <div className="bg-light p-2 rounded" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                <ul className="mb-0 list-unstyled">
                  {selectedRows.map((row, index) => (
                    <li key={index} className="text-sm">• {row.file_name}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={cancelBulkDelete} disabled={bulkDeleteLoading}>
            Cancel
          </Button>
          <Button variant="outline-danger" onClick={confirmBulkDelete} disabled={bulkDeleteLoading}>
            {bulkDeleteLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Deleting...
              </>
            ) : (
              `Delete ${selectedRows.length} Files`
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
}

export default ViewExportedFiles;
